import React, {useEffect, useState} from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import axios from 'axios';
import { Sentry } from "../sentryInstrumentReact";

function StoreSearch() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    async function fetchProducts() {
	  try {
		const response = await axios.get("/store/_api/productsforcart/");
		const formattedProducts = await response.data.results.map((item) => {
          return ({
			id: item.id,
			title: item.title,
          });
		});
		setProducts(formattedProducts);
	  } catch(error) {
		if (Sentry && Sentry.getClient()) {
          Sentry.captureException(error, {stage: "error retrieving products from API"});
		}
	  }
    }

    fetchProducts();
  },[]);


  const formatResult = (item) => {
    return (
      <>
        <span style={{ display: 'block', textAlign: 'left' }}>{item.title}</span>
      </>
    )
  }


  const handleOnSearch = (string, results) => {
    return;
  }

  const handleOnSelect = (item) => {
    return;
  }

  return (
    <div>
      <h2>StoreSearch</h2>
      <ReactSearchAutocomplete
          items={products}
          fuseOptions={{ keys: ["title", "subtitle", "description"] }}
          onSearch={handleOnSearch}
		      onSelect={handleOnSelect}
          showNoResultsText="no results!"
          showIcon={true}
          formatResult={formatResult}
          placeholder="placeholder string"
          styling={{
            border: "2px solid rgba(var(--form-outline-color), 1)",
            zIndex: 1000,
          }}
        />

    </div>
  );
}

export default StoreSearch;
